import type { CuentasFiltrosState } from './CuentasFiltros'

export const FILTROS_CUENTAS_INICIALES: CuentasFiltrosState = {
  busqueda: '',
  tipo: 'todos',
  institucion: 'todos',
  moneda: 'todos',
  mostrarInactivas: false,
}
